import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { MCIParametersModel, MCIParametersModelPagedResponseModel } from '../models';
import { ApiConfigService } from './api-config.service';

@Injectable({
    providedIn: 'root'
})
export class MCIParametersService extends BaseApiService {

     constructor( http: HttpClient,
            apiConfig: ApiConfigService) {
            super(http, apiConfig);
        }
        baseUrl = this.apiConfig.getBaseUrl();

    /**
     * Get all MCI parameters with pagination
     */
    getMCIParameters(page: number = 1, pageSize: number = 20, materialId?: string, materialName?: string): Observable<MCIParametersModelPagedResponseModel> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        if (materialId) {
            params = params.set('materialId', materialId);
        }
        if (materialName) {
            params = params.set('materialName', materialName);
        }

        return this.http.get<MCIParametersModelPagedResponseModel>(`${this.baseUrl}/api/v1/mci-parameters`, { params });
    }

    /**
     * Get MCI parameters by ID
     */
    getMCIParametersById(id: string): Observable<MCIParametersModel> {
        return this.http.get<MCIParametersModel>(`${this.baseUrl}/api/v1/mci-parameters/${id}`);
    }

    /**
     * Create new MCI parameters
     */
    createMCIParameters(mciParameters: MCIParametersModel): Observable<MCIParametersModel> {
        return this.http.post<MCIParametersModel>(`${this.baseUrl}/api/v1/mci-parameters`, mciParameters);
    }

    /**
     * Update MCI parameters
     */
    updateMCIParameters(id: string, mciParameters: MCIParametersModel): Observable<MCIParametersModel> {
        return this.http.put<MCIParametersModel>(`${this.baseUrl}/api/v1/mci-parameters/${id}`, mciParameters);
    }

    /**
     * Delete MCI parameters
     */
    deleteMCIParameters(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/api/v1/mci-parameters/${id}`);
    }

    /**
     * Get MCI parameters by material ID
     */
    getMCIParametersByMaterialId(materialId: string): Observable<MCIParametersModel> {
        return this.http.get<MCIParametersModel>(`${this.baseUrl}/api/v1/mci-parameters/material-id/${materialId}`);
    }

    /**
     * Search MCI parameters
     */
    searchMCIParameters(searchTerm: string): Observable<MCIParametersModel[]> {
        return this.http.get<MCIParametersModel[]>(`${this.baseUrl}/api/v1/mci-parameters/search?searchTerm=${searchTerm}`);
    }
}
